import React from 'react';
import cx from 'classnames';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export interface CloseButtonProps {
  onClick?: () => void;
  className?: string;
}

export function CloseButton({ onClick, className }: CloseButtonProps) {
  return (
    <FontAwesomeIcon
      icon={faTimes}
      className={cx(className, [
        'z-[999] v2-text-neutral-300 hover:v2-text-orange-700 absolute',
        'flex w-fit ml-auto text-[25px] cursor-pointer !w-5',
      ])}
      onClick={onClick}
    />
  );
}
